import React, { Component, ReactNode } from 'react';
import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';
import { Button, CircularProgress } from '@mui/material';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';

import { format } from './utils/format';
import { SeriesField } from './../../../core/types/Series';
import APCellStyles from './styles/APCell.style';
import { GetCurrenciesObjectMapping } from '../../../core/utils/GetCurrenciesData';
import { withTranslate } from '../../../core/TenantProvider';
import { ReactComponent as DownloadIcon } from "../../atoms/APDropDownMenu/assets/icons/icon-download.svg";
import {
  INVOICE_DOWNLOAD_LABEL,
  WIDE_ENABLED_FIELDS,
  WRAPPED_TEXT_ENABLED_COLUMN
} from '../../../core/utils/Constants/Constants';
import { actions as InvoicesActions } from '../../../redux/modules/invoices';

interface APCellProps extends WithStyles<typeof APCellStyles> {
  field: SeriesField,
  translate: Function,
  downloadInvoiceFile: Function,
}

class APCell extends Component<APCellProps, {}> {
  state = {
    isInvoiceLoading: false,
    showError: false
  }

  constructor(props: APCellProps) {
    super(props);
    this.getIcon = this.getIcon.bind(this);
    this.downloadButton = this.downloadButton.bind(this);
    this.handleFileDownload = this.handleFileDownload.bind(this);
    this.postFileDownloadAction = this.postFileDownloadAction.bind(this);
  }

  getIcon(value: any, classes: any) {
    const CountriesList = GetCurrenciesObjectMapping();
    const currenciesIconURL = CountriesList[value]?.icon;
    if (currenciesIconURL) {
      const currencyIcon = require(`../../../core/assets/CountriesList/${currenciesIconURL}.svg`);
      return (<span className={classes.itemIcon}>
        <img src={currencyIcon} alt="Currency Icon" />
      </span>);
    }
  }

  postFileDownloadAction = (response: boolean) => {
    this.setState({
      isInvoiceLoading: false,
      showError: !response
    });

    setTimeout(() => {
      this.setState({
        showError: false
      });
    }, 10000);
  }

  handleFileDownload = () => {
    const {
      field
    } = this.props;

    this.setState({ isInvoiceLoading: true });
    if (field.fieldPDFName) {
      this.props.downloadInvoiceFile(this.postFileDownloadAction, field.fieldPDFName);
    }
  }

  downloadButton = (value: ReactNode | null | undefined) => {
    const {
      classes,
      translate
    } = this.props;

    const {
      isInvoiceLoading,
      showError
    } = this.state;

    return (
      <>
        {showError &&
          <p className={classes.invoiceDownloadError}>
            {translate('invoices.section.invoice.download.error')}
          </p>
        }
        {isInvoiceLoading && <CircularProgress className={classes.loadingIcon} size={18} />}
        <Button className={classes.downloadButton}
          onClick={(event) => {
            event.preventDefault();
            this.handleFileDownload();
          }} color="primary" disableRipple={true}>
          <DownloadIcon className={classes.downloadIcon} /> {value}
        </Button>
      </>
    );
  }

  render() {
    const {
      classes,
      field,
      translate
    } = this.props;

    const value: string = format(field, translate);
    const isDisplayFlag: boolean = field.fieldName === 'sold' || field.fieldName === 'bought';
    const flag: JSX.Element | string = isDisplayFlag && field.fieldValue ? this.getIcon(field.fieldValue, classes) as JSX.Element : '';
    const DownloadElement: JSX.Element = this.downloadButton(value);

    const cellCls = classnames(classes.formattedCell, {
      [classes.currencyCell]: field.fieldType === 'currency' && WIDE_ENABLED_FIELDS.includes(field.fieldName),
      [classes.notRegistered]: field.fieldName === 'registereddate' && field.fieldType === 'no-data',
      [classes.formattedWrappedCell]: WRAPPED_TEXT_ENABLED_COLUMN.includes(field.fieldName)
    });

    return (
      <span className={cellCls}>

        {isDisplayFlag && flag}

        {field.fieldValuePrefix}
        {value === INVOICE_DOWNLOAD_LABEL ? DownloadElement : value}

        {field.customAttributes !== undefined && (
          <span className={classes.customAttributes}>
            {field.customAttributes.paid && (
              <span className={classes.paymentState}>
                {translate('series.table.custom.attribute.paid')}
              </span>
            )}

          </span>
        )}
      </span>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  downloadInvoiceFile: InvoicesActions.downloadInvoiceFile
}, dispatch);

export default connect(null, mapDispatchToProps)(
  withTranslate(
    withStyles(APCellStyles)(APCell)
  )
);